import {ReceivableScreen} from './receivables';

export {ReceivableScreen};
